export default {
    isEmpty: value => null === value || 0 === value || '' === value || undefined === value || 0 === value.length
}
